"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
class ChildNotFoundError extends client_library_1.ExtendableError {
    constructor(userId) {
        super(`Child with userId ${userId || 'unknown'} not found`);
        this.userId = userId;
    }
}
exports.default = ChildNotFoundError;
//# sourceMappingURL=ChildNotFoundError.js.map